import { takeEvery } from 'redux-saga/effects';
import * as actionTypes from '../redux/actionTypes';
import { submitIncomesSaga } from '../sagas/submitIncomesSaga';

export function* NDFL3LightRentalIncomeSaga() {
  yield takeEvery(actionTypes.SUBMIT, submitIncomesSaga);
}
